/* macroStyleWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./macroStyleWrapper.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIsMacro } from '../utils/useIsMacro';
// This overrides Editor styling on text components that affects chart components in macro module
var chartStyle = null;
export var withMacroStyleWrapper = function withMacroStyleWrapper(ChartComponent) {
  return function MacroStyleWrapper(props) {
    var isMacro = useIsMacro();
    return isMacro ? /*#__PURE__*/React.createElement("div", {
      className: ax(["_12r8nbxd _tc2g1gjq _1prk2smr _1x821gjq _1fcw1o8v _iz89u2gc _mobwu2gc _1g8nze3t _1dd0ze3t _1d2p131l _1o72nf1z _69vf1fxt _5fflze3t _12efze3t _679pze3t _ffvkze3t _e5dpze3t _1x99ze3t _vkdkze3t _1jbju2gc"])
    }, /*#__PURE__*/React.createElement(ChartComponent, props)) : /*#__PURE__*/React.createElement(ChartComponent, props);
  };
};